/* iframe-title-fix.js
   Adds descriptive title="" to iframes that arrive without one (apps, embeds, etc.).
   Won’t overwrite existing titles; safe for cross-origin iframes.
*/
(function () {
  'use strict';

  function describeFromURL(src) {
    if (!src) return 'Embedded content';
    try {
      var u = new URL(src, location.href);
      var host = u.hostname;
      var href = u.href;

      if (/youtube\.com|youtu\.be/.test(host)) return 'YouTube video player';
      if (/vimeo\.com/.test(host)) return 'Vimeo video player';
      if (/google\./.test(host) && /\/maps/.test(href)) return 'Google Maps location';
      if (/spotify\.com/.test(host)) return 'Spotify player';
      if (/soundcloud\.com/.test(host)) return 'SoundCloud player';
      if (/calendly\.com/.test(host)) return 'Calendly scheduling widget';
      if (/player\./.test(host) && /podcast|megaphone|buzzsprout|anchor/.test(href)) return 'Podcast player';
      if (/(judge\.me|loox|yotpo|okendo|stamped)/.test(host)) return 'Reviews widget';
      if (/facebook\.com/.test(host)) return 'Facebook embed';
      if (/(x\.com|twitter\.com)/.test(host)) return 'X (Twitter) embed';
      if (/cdn\.shopify\.com/.test(host)) return 'Embedded Shopify content';
    } catch (e) { /* no-op */ }
    return 'Embedded content';
  }

  function setTitleIfMissing(iframe) {
    if (!iframe || iframe.hasAttribute('title')) return;
    var aria = iframe.getAttribute('aria-label');
    var src = iframe.getAttribute('src') || '';
    var title = (aria && aria.trim()) ? aria : describeFromURL(src);
    iframe.setAttribute('title', title);
  }

  function scan(root) {
    root.querySelectorAll('iframe:not([title])').forEach(setTitleIfMissing);
  }

  function onNodeAdded(node) {
    if (node.nodeType !== 1) return;
    if (node.tagName === 'IFRAME') setTitleIfMissing(node);
    else scan(node);
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(document); });
    } else {
      scan(document);
    }
    // Handle iframes injected later by apps
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) onNodeAdded(added[j]);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  init();
})();
